import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsys.fund.item');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsys-fund-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsys.fund.item/view.scss */
/* src/app/portal.lpsys.fund.item/view.scss: no such file or directory */`],
})
export class PortalLpsysFundItemComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() status: any;
    @Input() fund_id: any;
    @Input() menu: any;

    public fund: any = null;
    public role: any;
    public fund_status: any;
    public investments: any = [];
    public isUserStatus: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public isLoading: boolean = false;

    public async load() {
        if (this.isLoading) return;
        this.isLoading = true;
        const { data } = await wiz.call("info", { id: this.fund_id });
        this.fund = data.info;
        this.role = data.role;
        this.fund_status = data.status;
        this.investment = data.investment;

        this.isUserStatus = false;
        try {
            if (this.fund_status.status == '참여' || this.fund_status.status == '신청' || this.fund_status.status == '해산') {
                this.isUserStatus = true;
            }
        } catch (e) {
        }

        this.isLoading = false;
        await this.service.render();
    }

    public linkFundMenu(menu: string) {
        return `/fund/${this.status}/${this.fund_id}/${menu}`;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-gray-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-indigo-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-gray-700 hover:bg-gray-50 hover:text-indigo-600";
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }
}

export default PortalLpsysFundItemComponent;